module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAAAs0lEQVRIie2VsQ3CMBRE32cHKKDJPFRUSQYAIXkfEIIJ3NIwTlJkj6NASIYuHxJF4Ku+T/I92ZbOkDWSzLMpxrgBzoDMbFeW5bVvxswDBg7AHFhIOnoCvOBlMq/GBH+sDM7g3wO/NFeMcc2jHIovc1pJoa7r29N4P/FpAChAYWaX1JjGG0vaA80AnMbMtqnh/Z2Urquq6p0zjavO4Az+a3CbzK7CcYElBaADOjMLnoys0XQHzLImEFXJkPsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plus_c.png
// module id = 8agP
// module chunks = 2